import { types } from "../types/types"

export const saveMunicipios = (data) => {
    return {
        type: types.municipios,
        payload: data
    }
}